module.exports = __webpack_public_path__ + "static/media/paco-rabanne.10c9fc04.jpg";